// Role definitions
export const ROLES = {
  ADMIN: 'ADMIN',
  PACKER: 'PACKER',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

// Routes accessible by each role
// ADMIN has access to all routes (indicated by '*')
// Other roles have specific route patterns
export const ROLE_ROUTES: Record<Role, string[]> = {
  [ROLES.ADMIN]: ['*'], // All routes
  [ROLES.PACKER]: [
    '/customers/shipments',
    '/customers/shipments/:id',
    '/customers/orders/inbound/new',
    '/suppliers/orders/inbound/new',
    '/suppliers/orders',
    '/suppliers/orders/:id',
    '/profile',
  ],
};

// Default route for each role (where to redirect after login or when accessing unauthorized route)
export const ROLE_DEFAULT_ROUTES: Record<Role, string> = {
  [ROLES.ADMIN]: '/dashboard',
  [ROLES.PACKER]: '/customers/shipments',
};

// Helper function to check if a route matches a pattern
const matchRoute = (route: string, pattern: string): boolean => {
  if (pattern === '*') return true;
  
  // Convert pattern like '/customers/shipments/:id' to regex
  const regexPattern = pattern
    .replace(/:[^/]+/g, '[^/]+') // Replace :param with regex
    .replace(/\//g, '\\/'); // Escape slashes
  
  const regex = new RegExp(`^${regexPattern}$`);
  return regex.test(route);
};

// Check if a role has access to a specific route
export const hasRouteAccess = (role: Role | string, route: string): boolean => {
  const allowedRoutes = ROLE_ROUTES[role as Role];
  
  if (!allowedRoutes) return false;
  
  return allowedRoutes.some(pattern => matchRoute(route, pattern));
};
